import React from "react";
import ProgressSvg from "../../../assets/svgicons/progress-bar/progress_bar_3_5.svg";

const Progress_3_5 = (props) => {
  return <img src={ProgressSvg} alt="Progress 3-5" {...props} />;
};

export default Progress_3_5;
